import { AfterContentChecked, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Color } from '@app/shared/models/color.model';
import { ButtonIcon, ButtonSize, ButtonStyle } from '@app/shared/components/atoms/buttons/button.type';
import { AlertTypeEnum } from '@app/shared/components/molecules/alert-card/alert-card.model';
import { Size, Style } from '../../atoms/icon/icon.component';

type StyleOption = {
  color?: string;
  customIconSrc?: string;
  strip?: boolean;
  iconCenterAlign?: boolean;
};

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrl: './alert-card.component.scss',
  standalone: false,
})
export class AlertCardComponent implements AfterContentChecked {
  @Input() type?: AlertTypeEnum = AlertTypeEnum.Info;

  @Input() description?: string;

  @Input() styleOption?: StyleOption;

  @Input() title?: string;

  @Input() closeIcon?: boolean = false;

  @Output() closeEvent = new EventEmitter<void>();

  @Input() actionText?: string;

  @Input() actionCallback?: () => void;

  constructor(private el: ElementRef) {}

  public get getType() {
    const alertTypeConfig = {
      [AlertTypeEnum.Success]: { type: 'success', iconClass: 'ph-check-circle', color: Color.positive },
      [AlertTypeEnum.Error]: { type: 'danger', iconClass: 'ph-warning-circle', color: Color.danger500 },
      [AlertTypeEnum.Info]: { type: 'info', iconClass: 'ph-info', color: Color.info500 },
      [AlertTypeEnum.Warning]: { type: 'warning', iconClass: 'ph-warning', color: Color.warning500 },
    };

    return alertTypeConfig[this.type!];
  }

  ngAfterContentChecked() {
    const { style } = this.el.nativeElement;
    style.setProperty('--alert-color', this.styleOption?.color || this.getType.color);

    if (!this.styleOption?.strip) {
      style.setProperty('--border-left-style', 'none');
    }
  }

  protected readonly Color = Color;

  protected readonly Style = Style;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonStyle = ButtonStyle;

  protected readonly ButtonIcon = ButtonIcon;

  protected readonly Size = Size;
}
